module.exports = __webpack_public_path__ + "static/img/bg_vip_desc_dialog_bg_1.5e54f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_vip_desc_dialog_bg_1.png
// module id = 3lsD
// module chunks = 0